import styles from "./HomeHero.module.scss";
import Banner from "../../../../components/Banner/Banner";
import img from "../../../../assets/images/prestation/regard.webp";

function HomeHero() {
  return (
    <section className={styles.hero}>
      <Banner backgroundImage={img} />

      <div className={styles.overlay}>
        <div className={styles.content}>
          <div className={styles.brandLine}>
            <span className={styles.brandName}>ÉCLAT DE BEAUTÉ</span>
            <span className={styles.brandBy}>BY VIRGINIE</span>
          </div>

          <h1 className={styles.title}>
            La beauté
            <span>vient à vous.</span>
          </h1>

          <div className={styles.separator} />

          <p className={styles.subtitle}>
            Des soins esthétiques professionnels,
            <br />
            dans le confort de votre maison.
          </p>

          <p className={styles.area}>
            VALENCIENNES <span>·</span> 10 KM AUTOUR
          </p>
        </div>
      </div>
    </section>
  );
}

export default HomeHero;
